import "components/ui/Labels/Labels.scss";
import Label from "components/ui/Labels/Label";

function Labels({ items, variant }) {
  if (!items || !Array.isArray(items)) {
    return null;
  }
  return (
    <div className="labels">
      { items.map((item, index) =>
        <Label key={ index }
               variant={ variant }>
          { item }
        </Label>
      ) }
    </div>
  )
}

export default Labels;
